<template>
  <div class="contentBox">
    <navBox :id="navId" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>添加会员</p>
          </div>
          <div class="searchBox clear">
            <div class="search-item">
              <p>会员名称：</p>
              <input type="text" placeholder="请输入要搜索的会员名称" v-model="obj.title">
            </div>
            <div class="search-item">
              <p>排序：</p>
              <el-select v-model="obj.sort" placeholder="请选择">
                <el-option
                  v-for="item in sortList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="search-item">
              <p>状态：</p>
              <el-select v-model="obj.publish_status" placeholder="请选择">
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="search-item">
              <p>创建时间：</p>
              <el-select v-model="obj.create_time" placeholder="请选择">
                <el-option
                  v-for="item in createList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.title">{{item.title}}</p>
              <p :title="item.type==1?'苹果':'安卓'">{{item.type==1?'苹果':'安卓'}}</p>
              <p :title="item.price">{{item.price}}</p>
              <p :title="item.vip_time">{{item.vip_time}}</p>
              <p>
                <el-switch
                  @change="switchChange(item)"
                  v-model="item.publish_status"
                  active-color="#457AFF"
                  inactive-color="#CBCBCB">
                </el-switch>
              </p>
              <p :title="item.sort">{{item.sort}}</p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p>
                <button title="修改" @click="reviseShow(item)" class="btn btn-revise"></button>
                <button title="删除" @click="removeShow(item)" class="btn btn-remove"></button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv" style="height: auto;">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="closeSub">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>

    <!-- 添加 -->
    <div class="msgBox " v-if="addType">
      <div class="contv">
        <p class="title">{{addType=='add'?'添加会员':'编辑会员'}}</p>
        <form>
          <div class="write-txt">
            <p>会员名称：</p>
            <input type="text" v-model="addObj.title">
          </div>
          <div class="write-txt">
            <p>设备类型：</p>
            <el-radio-group v-model="addObj.type">
              <el-radio label="1">苹果</el-radio>
              <el-radio label="2">安卓</el-radio>
              <!-- <el-radio label="3">后台</el-radio> -->
            </el-radio-group>
          </div>
          <div class="write-txt" v-if="addObj.type==1">
            <p>连续订阅：</p>
            <el-select v-model="addObj.bind_id" placeholder="请选择">
              <el-option
                v-for="item in vipList"
                :key="item.id"
                :label="item.title"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="write-txt">
            <p>会员有效期：</p>
            <input type="number" v-model="addObj.vip_time" style="width: 50px;padding: 0 10px;margin-right: 20px;">
            <el-radio-group v-model="vip_date">
              <el-radio label="d">天</el-radio>
              <el-radio label="m">月</el-radio>
              <el-radio label="y">年</el-radio>
            </el-radio-group>
          </div>
          <div class="write-txt">
            <p>价格：</p>
            <input type="number" v-model="addObj.price">
          </div>
          <div class="write-txt">
            <p>单价：</p>
            <input type="text" v-model="addObj.unit_price_value">
          </div>
          <div class="write-txt">
            <p>角标：</p>
            <input type="text" v-model="addObj.act_str">
          </div>
          <div class="write-txt">
            <p>练习时间（分钟）：</p>
            <input type="text" v-model="addObj.practice_time">
          </div>
          <div class="write-txt">
            <p>模式：</p>
            <el-select v-model="addObj.model" placeholder="请选择">
              <el-option label="会员页" value="1"></el-option>
              <el-option label="收银台" value="2"></el-option>
            </el-select>
          </div>
          <div class="write-txt">
            <p>排序：</p>
            <el-select v-model="addObj.sort" placeholder="请选择">
              <el-option
                v-for="item in 10"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="write-txt">
            <p>是否默认选中：</p>
            <el-radio-group v-model="addObj.is_selected">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="saveSub">确认</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { getVipList, saveVip ,getVipIphoneList ,getVipDetail,delVip,updateVipStatus} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "vip",
  data() {
    return {
      navId:'4',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'会员名称'},
        {id:3,title:'设备类型'},
        {id:4,title:'价格'},
        {id:5,title:'有效期'},
        {id:6,title:'状态'},
        {id:7,title:'排序'},
        {id:8,title:'创建时间'},
      ],
      dataList:[
      ],
      addType:'',
      removeType:false,
      obj:{
        page:1,
        rows:10,
        title:'',
        publish_status:9,
        sort:'asc',
        create_time:'asc'
      },
      addObj:{
        type:'1',
        model:'1',
        title:'',
        price:'',
        unit_price_value:'',
        vip_time:'',
        sort:'',
        is_selected:'1',
        act_str:'',
        bind_id:-1
      },
      sortList:[
        {id:1,title:'正序',value:'asc'},
        {id:2,title:'倒序',value:'desc'},
      ],
      statusList:[
        {id:1,title:'已开启',value:1},
        {id:2,title:'已隐藏',value:0},
        {id:3,title:'未选择',value:9},
      ],
      createList:[
        {id:1,title:'正序',value:'asc'},
        {id:2,title:'倒序',value:'desc'},
      ],
      totalPage:0,
      vip_date:'',
      token:'',
      vipList:[
        {id:-1,title:'绑定自己'}
      ],
      removeID:''
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.getVipData();
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },
    async getVipData(){
      var that = this;
      try {
        const response = await getVipIphoneList(this.token);
        if(response.code == 200){
          response.data.forEach(function(item,index){
            that.vipList.push(item);
          })
          that.$forceUpdate();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj = {
        page:1,
        rows:10,
        title:'',
        publish_status:9,
        sort:'asc',
        create_time:'asc'
      };
      this.addObj = {
        type:'1',
        model:'1',
        title:'',
        price:'',
        unit_price_value:'',
        vip_time:'',
        sort:'',
        is_selected:'1',
        act_str:'',
        bind_id:-1
      }
      this.dataList = [];
      this.getList();
    },

    async switchChange(e){
      var that = this;
      var obj = {
        id:e.id,
        publish_status:e.publish_status==false?0:1,
      };
      try {
        const response = await updateVipStatus(obj,this.token);
        if(response.code == 200){
          that.$message('发布状态修改成功！');
          that.getList();  
        } else {
          that.$message(response.msg);
          e.publish_status = !e.publish_status;
        }
      } catch (error) {
        that.$message(error);
        e.publish_status = !e.publish_status;
      }
    },

    async getList(){
      var that = this;
      try {
        const response = await getVipList(this.obj,this.token);
        if(response.code == 200){
          response.data.list.forEach(function(item,index){
            if(item.publish_status==0){
              item.publish_status=false
            } else {
              item.publish_status=true
            }
          })
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;    
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addSub(){
      this.addType = 'add';
    },

    async saveSub(){
      var that = this;
      if(this.addObj.type == 2){
        if(this.addObj.bind_id){
          delete this.addObj.bind_id;
        }
      }
      this.addObj.vip_time = this.addObj.vip_time + this.vip_date;
      if(this.addObj.title == ''){
        that.$message('请输入会员名称！');
        return false;
      }
      if(this.addObj.price == ''){
        that.$message('请输入价格！');
        return false;
      }
      if(this.addObj.unit_price_value == ''){
        that.$message('请输入单价！');
        return false;
      }
      if(this.addObj.sort == ''){
        that.$message('请输入排序！');
        return false;
      }
      // if(this.addObj.act_str == ''){
      //   that.$message('请输入角标！');
      //   return false;
      // }
      try {
        const response = await saveVip(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.addType = '';
          that.resetSub(); 
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async reviseShow(e){
      var that = this;
      try {
        const response = await getVipDetail({id:e.id},this.token);
        if(response.code == 200){
          response.data.type = JSON.stringify(response.data.type);
          response.data.is_selected = JSON.stringify(response.data.is_selected);
          response.data.model = JSON.stringify(response.data.model);
          response.data.sort = JSON.stringify(response.data.sort);
          that.vip_date = JSON.parse(JSON.stringify(response.data.vip_time.split('')[response.data.vip_time.split('').length-1]));
          that.addObj = JSON.parse(JSON.stringify(response.data));
          var time = '';
          response.data.vip_time.split('').forEach(function(item,index){
            if(index == (response.data.vip_time.split('').length-1)){

            } else {
              time = time + item
            }
          })
          that.addObj.vip_time = time;
          that.addType = 'revise';
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    removeShow(e){
      var that = this;
      this.removeType = true;
      this.removeID = e.id;
    },

    async removeSub(e){
      var that = this;
      try {
        const response = await delVip({id:this.removeID},this.token);
        if(response.code == 200){
          that.$message('成功');
          that.removeType = '';
          that.resetSub();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.removeType = false;
      this.addType = '';
      this.addObj = {
        type:'1',
        model:'1',
        title:'',
        price:'',
        unit_price_value:'',
        vip_time:'',
        sort:'',
        is_selected:'1',
        act_str:'',
      };
      this.removeID = '';
    }
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 9 );
  }

  .btn-remove,
  .btn-revise{
    background-image: url(~@/assets/images/btn-revise.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-remove{
    background-image: url(~@/assets/images/btn-remove.png);
    margin-left: 50px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox textarea{
    width: 80%;
    height: 65px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: right;
  }

  .write-btnBox .btn{
    width: 120px;
    height: 56px;
    line-height: 56px;
    border-radius: 16px;
    color: #fff;
    background-color: #6E2FFF;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 40px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.searchBox>>>.search-item input{
  width: 160px;
}

.msgBox .contv{
  height: 80%;
}

.msgBox .btnBox{
  margin-top: 50px;
}

.msgBox>>>.el-radio__label{
  font-size: 15px;
}
.msgBox>>>.el-radio-group .el-radio{
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/speech/vip.vue